import * as React from "react";
const Clock = (props) => (
  <svg
    width={10}
    height={10}
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5 10C2.24186 10 0 7.75814 0 5C0 2.24186 2.24186 0 5 0C7.75814 0 10 2.24186 10 5C10 7.75814 7.75814 10 5 10ZM5 0.697674C2.62791 0.697674 0.697674 2.62791 0.697674 5C0.697674 7.37209 2.62791 9.30233 5 9.30233C7.37209 9.30233 9.30233 7.37209 9.30233 5C9.30233 2.62791 7.37209 0.697674 5 0.697674Z"
      fill="#969BA1"
    />
    <path
      d="M6.72526 6.82798C6.66479 6.82798 6.60433 6.81403 6.54851 6.77682L5.10665 5.91635C4.74851 5.7024 4.4834 5.23263 4.4834 4.81868V2.9117C4.4834 2.72101 4.64154 2.56287 4.83224 2.56287C5.02293 2.56287 5.18107 2.72101 5.18107 2.9117V4.81868C5.18107 4.98612 5.32061 5.23263 5.46479 5.31635L6.90665 6.17682C7.0741 6.27449 7.12526 6.48845 7.02758 6.65589C6.95782 6.76752 6.84154 6.82798 6.72526 6.82798Z"
      fill="#969BA1"
    />
  </svg>
);
export default Clock;
